import Swal from "sweetalert2";
import * as Type from "store/actionTypes/product";
import { getProducts, getProductDashboard as getProductDashboardService, getProductRecap as getProductRecapService, createProduct as createProductService, updateProduct as updateProductService, deleteProduct as deleteProductService } from "services";

export const getProduct =
  (params = "") =>
  async (dispatch) => {
    try {
      dispatch({
        type: Type.PRODUCT_REQUEST,
      });
      const res = await getProducts(params);
      dispatch({
        type: Type.GET_PRODUCT_SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      Swal.fire("error", err.message, "error");
      dispatch({
        type: Type.GET_PRODUCT_ERROR,
        payload: err.message,
      });
    }
  };

export const getProductDashboard =
  (params = "") =>
  async (dispatch) => {
    try {
      dispatch({
        type: Type.PRODUCT_REQUEST,
      });
      const res = await getProductDashboardService(params);
      dispatch({
        type: Type.GET_PRODUCT_SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      Swal.fire("error", err.message, "error");
      dispatch({
        type: Type.GET_PRODUCT_ERROR,
        payload: err.message,
      });
    }
  };

export const getProductRecap =
  (params = "") =>
  async (dispatch) => {
    try {
      dispatch({
        type: Type.PRODUCT_REQUEST,
      });
      const res = await getProductRecapService(params);
      dispatch({
        type: Type.GET_PRODUCT_SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      Swal.fire("error", err.message, "error");
      dispatch({
        type: Type.GET_PRODUCT_ERROR,
        payload: err.message,
      });
    }
  };

export const createProduct = (data) => async (dispatch) => {
  try {
    dispatch({
      type: Type.PRODUCT_REQUEST,
    });

    const res = await createProductService(data);

    dispatch({
      type: Type.CREATE_PRODUCT_SUCCESS,
      payload: res.message,
    });
  } catch (err) {
    Swal.fire("error", err.message, "error");
    dispatch({
      type: Type.CREATE_PRODUCT_ERROR,
      payload: err.message,
    });
  }
};

export const updateProduct = (data, id) => async (dispatch) => {
  try {
    dispatch({
      type: Type.PRODUCT_REQUEST,
    });

    const res = await updateProductService(data, id);
    dispatch({
      type: Type.UPDATE_PRODUCT_SUCCESS,
      payload: res.message,
    });
  } catch (err) {
    Swal.fire("error", err.message, "error");
    dispatch({
      type: Type.UPDATE_PRODUCT_ERROR,
      payload: err.message,
    });
  }
};

export const deleteProduct = (id) => async (dispatch) => {
  try {
    dispatch({
      type: Type.PRODUCT_REQUEST,
    });
    const res = await deleteProductService(id);
    Swal.fire("success", res.message, "success");
    dispatch({
      type: Type.DELETE_PRODUCT_SUCCESS,
      payload: res.message,
    });
  } catch (err) {
    Swal.fire("error", err.message, "error");
    dispatch({
      type: Type.DELETE_PRODUCT_ERROR,
      payload: err.message,
    });
  }
};
